/**
 * Central logout notifier so the networking layer never controls routing.
 * The app sets a handler (e.g. navigate("/login", { state: reason })); client calls triggerLogout(reason).
 * reason can be e.g. { sessionExpired: true } so the login page can show "Session expired. Please log in again."
 */
let logoutHandler = null;

export function setLogoutHandler(fn) {
  logoutHandler = typeof fn === "function" ? fn : null;
}

export function triggerLogout(reason) {
  if (typeof logoutHandler === "function") logoutHandler(reason);
}
